import { takeLatest } from 'redux-saga/effects'
import { UPLOAD_IMAGE_SAGA } from 'src/store/types/adminData'
import postImage from './postImage'

export function* uploadImageSaga() {
  yield takeLatest(UPLOAD_IMAGE_SAGA, postImage)
}
